var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"contentBox",domProps:{"innerHTML":_vm._s(this.contentHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }